<template>
  <div>
    <nav
      class="navbar is-header-scroll"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="container">
        <div class="navbar-brand">
          <div class="navbar-item">
            <div class="field">
              <div class="is-flex">
                <div class="control">
                  <input
                    v-model="value"
                    class="input"
                    type="text"
                    placeholder="Member Search"
                    @keyup.enter="search()"
                  >
                </div>
                <div
                  class="control"
                  @click="search()"
                >
                  <a class="button is-dark">
                    <span class="icon is-right">
                      <i class="far fa-search" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="navbar-burger burger"
            :class="{'is-active': isActive}"
            data-target="navMenubd-example"
            @click="toggleActive()"
          >
            <span />
            <span />
            <span />
          </div>
        </div>
        <navigation
          :is-active="isActive"
          @hideMenuInMobile="hideMenuInMobile"
        />
      </div>
    </nav>
  </div>
</template>

<script>
  import Navigation from './Navigation.vue'
  export default {
    name: 'HeaderScroll',
    components: {
      Navigation
    },
    data () {
      return {
        isActive: false,
        value: ''
      }
    },
    methods: {
      toggleActive () {
        this.isActive = !this.isActive
      },
      hideMenuInMobile () {
        this.isActive = false
      },
      search () {
        if (!this.value) return false
        this.$emit('search', this.value)
      }
    }
  }
</script>
